import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Table, Input, Button, ButtonGroup, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Label } from 'reactstrap';
import ColumnFilters from './components/ColumnFilters';
import Loader from 'components/Loader';


import sortdown from 'assets/icon/Sort_Down.svg';

import Pagination from 'components/Pagination';
import leftArrowIcon from 'assets/icon/pf-arrow-left.svg';
import rightArrowIcon from 'assets/icon/pf-arrow-right.svg';
import { find } from 'lodash';
// import collapse from "assets/icon/collapse-icon.svg";
// import collapseclose from "assets/icon/collapse-icon-close.svg";

import searchIcon from 'assets/icon/search.png';
import crossIcon from 'assets/icon/cross.png';
import download from "assets/icon/download-icon.svg";

let keysName = [];
let columnChangedFilters = [];
let isHaveColFilter = false;

let countryList = [
  { id: 1, name: "12 - Column" },
  { id: 2, name: "12 - Column" },
]

const ReactStrapTable = ({
  id,
  columns,
  data,
  fixedColumn,
  handleSort = () => '',
  loading,
  reset,
  loader,
  hasScrollArrow = true,
  onFilterCancel = () => '',
  onSearchColumnFilters = () => '',
  pageSize,
  onPageSizeChange = () => '',
  onPageSizeReportChange = () => '',
  children,
  onExport,
  AllExport,
  slelectedExport,
  onSelectColoums,
  hasPagination,
  isCaseManagementTable,
  onPageChange,
  onPageReportChange,
  currentPage,
  totalRecords,
  filters,
  reportFilters,
  isReportConfiguration,
  reportTotalRecords,
  reportPageSize,
  reportCurrentPage,
  researchNeededCount = 0,
  eligibleCount = 0,
  inEligibleCount = 0,
  hasNoEligibility = true,
  hasExportPermission = true,
  gridMsg = 'No record found',
  hasColselect = false,
  autoselectlist1,
  startPage,
  setStartPage,
  sort,
  resetfilter,
  setSort,
  hidden

  // toggleSider,
  // collapseSider,
  // showtoggle,
}) => {

  const [key, setKey] = useState('');
  const [resetField, setResetField] = useState(false);
  const [hasVisibleScrollArrow, setVisibleScrollArrow] = useState(false);
  const [hasLeftArrow, setLeftArrow] = useState(false);
  const [hasRightArrow, setRightArrow] = useState(false);
  const [rSelected, setRSelected] = useState('off');
  const [colFilterEnable, setColFilterEnable] = useState(false);
  const [sortKey, setSortKey] = useState('desc');
  const [SortKey1, setSortKey1] = useState('asc')
  const selectRef = useRef(null);
  const [colvalue, setColvalue] = useState([])
  const [colvalue1, setColvalue1] = useState(false)


  // useEffect(() => {
  //   columnChangedFilters = [];
  // }, []);
  const getUpdateColum = () => {
    const updateCol = [];
    const col = columns[0];
    if (!col?.action && colFilterEnable) {
      updateCol.push({
        dataField: 'Options',
        text: 'Options',
        width: 80,
        show: false,
        disabled: true,
        hideColFilter: true,
        action: true,
      });
    }
    return [...updateCol, ...columns];
  };
  useEffect(() => {
    setKey('');
    setSortKey("desc")
  }, [reset]);


  useEffect(() => {
    onClickFilter("off")
    setSortKey("desc")
    if (
       colvalue1 == true 
       &&  
       sort == false) {

      onColHeaderClick(colvalue, true)
    }

  }, [resetfilter]);
  // console.log(sortKey, "sortkey", resetfilter)
  // const removeSort = (keys) => {
  //   keysName.push(keys);
  //   const filter = keysName.filter((item) => item === keys);
  //   if (filter.length === 3) {
  //     setKey('');
  //     setSortKey('desc');
  //     keysName = [];
  //   } else {
  //     const sortObj = {
  //       order: sortKey === 'asc' ? 'asc' : 'desc',
  //       orderBy: keys,
  //     };
  //     setSortKey(sortObj.order);
  //     if (isHaveColFilter) {
  //       const apiFilter = {
  //         ...filters,
  //         ...sortObj,
  //         filters: [...columnChangedFilters],
  //       };
  //       handleSort(apiFilter, true);
  //     } else {
  //       const apiFilter = { ...filters, ...sortObj };
  //       handleSort(apiFilter);
  //     }
  //   }
  // };

  const removeSortDown = (keys) => {
    keysName.push(keys);
    const filter = keysName.filter((item) => item === keys);
    if (filter.length === 3) {
      setKey('');
      setSortKey1('asc');
      setSortKey('asc')
      keysName = [];
    } else {
      const sortObj = {
        order: SortKey1 === 'desc' ? 'desc' : 'asc',
        orderBy: keys,
      };
      setSortKey1(sortObj.order);
      setSortKey(sortObj.order)
      if (isHaveColFilter) {
        const apiFilter = {
          ...filters,
          ...sortObj,
          filters: [...columnChangedFilters],
        };
        handleSort(apiFilter, true);
      } else {
        const apiFilter = { ...filters, ...sortObj };
        handleSort(apiFilter);
      }
    }
  };
  // console.log(keysName, "names")

  const onColHeaderClickTop = (col) => {
    if (col.disabled) return;
    setKey(col.dataField);
    removeSort(col.dataField);
  };

  const onColHeaderClickDown = (col) => {
    if (col.disabled) return;
    setKey(col.dataField);
    removeSortDown(col.dataField);
  };
  const [activeColumn, setActiveColumn] = useState(null);

  // const onColHeaderClick = (col) => {
  //   setActiveColumn(col.dataField);
  // };


  const removeSort = (keys, colume) => {
    //  debugger;
    keysName.push(keys);
    const filter = keysName.filter((item) => item === keys);
    if (filter.length === 3) {
      setKey("");
      setSortKey("desc");
      keysName = [];
      // setColvalue1(false)
    }
    else if (colume == true) {
      keysName = []
      setSort(true)
      setColvalue1(false) 

      const sortObj = {
        order: "desc",
        orderBy: keys,
      };
      setSortKey(sortObj.order);
      if (isHaveColFilter) {
        const apiFilter = {
          ...filters,
          ...sortObj,
          filters: [...columnChangedFilters],
        };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys, true, columnChangedFilters);
        handleSort(apiFilter, true);
        setSort(true)
      }
      else {
        const apiFilter = { ...filters, ...sortObj };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys);
        handleSort(apiFilter);
      }
    }
    else {
      const sortObj = {
        order: sortKey === "desc" ? "asc" : "desc",
        orderBy: keys,
      };
      setSortKey(sortObj.order);
      if (isHaveColFilter) {
        const apiFilter = {
          ...filters,
          ...sortObj,
          filters: [...columnChangedFilters],
        };
                setSort(true)

                setColvalue1(true)

        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys, true, columnChangedFilters);
        handleSort(apiFilter, true);
      } else {
                setSort(true)

                setColvalue1(true)

        const apiFilter = { ...filters, ...sortObj };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys);
        handleSort(apiFilter);
      }
    }
  };

  const onColHeaderClick = (col, colume) => {
    // debugger;
     setColvalue1(true) 
    setColvalue(col)
    if (col.disabled) return;
    setKey(col.dataField);
    removeSort(col.dataField, colume);
  };
  // console.log(sort, sortKey)
  const headerRenderer = () => {
    const cols = getUpdateColum().map((col, index) => {
      // const isActive = key === col.dataField;

      // const sortingClass = isActive && sort
      //   ? `active-sorting-${sortKey === 'asc' ? 'down' : 'up'} active-sorting-${SortKey1 === 'desc' ? 'up' : 'down'}`
      //   : '';

      return (
        <th
          className={
            key === col.dataField && (sort==true
                 && colvalue1 == true 
              
              )
              ? `active-sorting-${sortKey === "asc" ? "down" : "up"}`
              : ""
          }
          width={col.width || 100}
          onClick={() => {
            col.sort ? onColHeaderClick(col) : "";
          }}
          hidden={!col.show}
        >


          {/* {col.text}
          {col.sort == true ?

            <span className='' style={{ position: "relative",
              verticalAlign: "sub",
              marginTop: "7px",}}>
              <img  style={{ marginLeft: "0px" }} src={sortdown} alt="" onClick={() => {
                // col.sort && totalRecords > 0 ? 
                onColHeaderClickTop(col)
                //  : '';
              }} />
              <img className='filters_col' src={sortup} alt=""
                onClick={() => {
                  // col.sort && totalRecords > 0 ?
                   onColHeaderClickDown(col) 
                  //  : '';
                }}
              />
            </span> : ""} */}
          <div className="d-flex align-items-center justify-content-between">
            <div className="" style={{ width: col.width - 17 }}>
              {col.text}
            </div>
            {col.sort == true && sortKey == "desc" && keysName.length == 0 ? (
              <span
                className=""
                style={{
                  // marginLeft: "8px",
                  position: "relative",
                  verticalAlign: "sub",
                  marginTop: "7px",
                }}
              >
                <img
                  src={sortdown}
                  style={{ marginLeft: "0px" }}
                  alt=""
                //  onClick={() => {
                //    col.sort ? onColHeaderClickTop(col) : '';
                // }}
                />
                <img
                  className="filters_col"
                  src={sortdown}
                  alt=""
                // onClick={() => {
                //   col.sort ? onColHeaderClickDown(col) : '';
                // }}
                />
              </span>
            ) : (
              <div style={{ width: "17px" }}></div>
            )}
          </div>
        </th>
      );
    });
    return (
      <thead key='headerrow'>
        <tr>
          {/* {colFilterEnable && columns[0].action ? <th width={100}>Options</th> : ""} */}
          {cols}
          {/* {colFilterEnable && <th width={100}>Options</th>} */}
        </tr>
      </thead>
    );
  };
  const renderRow = () => {
    if (data.length) {
      const rows = data.map((row, index) => {
        const rowItem = getUpdateColum().map((col) => {
          // if (index === 0 && colFilterEnable) {
          //   return <th key="option" width={100}></th>;
          // }
          if (col.cellRenderer) {
            return (
              <td
                key={col.dataField}
                width={col.width || 100}
                className={col.edit ? 'py-1' : col.className || ''}
                hidden={!col.show}
              >
                {col.cellRenderer(row, col)}
              </td>
            );
          }
          return (
            <td key={col.dataField} width={col.width || 100} hidden={!col.show}>
              {row[col.dataField]}
            </td>
          );
        });
        return (
          <tr key={index}>
            {rowItem}
            {/* {colFilterEnable && <td width={100}></td>} */}
          </tr>
        );
      });
      return rows;
    } else {
      return (
        <tr>
          <td colSpan={getUpdateColum().length} className='text-center'>
            {loading ? 'Loading...' : gridMsg}
          </td>
        </tr>
      );
    }
  };

  const handleColumnFilterChange = ({ target: { value } }, col, type, filterType) => {
    const { dataField } = col;
    const obj = {
      filterName: dataField,
      filterType: filterType === "" ? 1 : filterType,
      // filterType: col.inputType === "date" ? 12 : col.inputType === "number" ? 13 : col.inputType === "pstext" ? 3 : filterType === "" ? 1 : filterType,
    };
    if (!value) {
      const filter = columnChangedFilters?.filter(
        (item) => item.filterName !== dataField
      );
      columnChangedFilters = filter;
      return;
    }
    const findObj = find(columnChangedFilters, {
      filterName: dataField,
    });
    if (findObj) {
      if (type === 'field') {
        findObj.filterValue = value;
      } else {
        findObj.filterType = parseInt(value);
      }
    } else {
      if (type === 'field') {
        obj.filterValue = value;
      } else {
        obj.filterType = parseInt(value);
      }
      const colFilters = [...columnChangedFilters, ...[obj]].filter(
        (item) => item.filterValue
      );
      columnChangedFilters = colFilters;
    }
  };

  const onSearchFilter = () => {
    isHaveColFilter = true;
    onSearchColumnFilters(columnChangedFilters);
  };

  const onCancelFilter = () => {
    isHaveColFilter = false;
    onFilterCancel();
    setResetField((pre) => !pre);
    columnChangedFilters = [];
  };

  const columnFilters = () => {
    var ids = [];
    if (hasColselect) {
      if (autoselectlist1.length > 0)
        for (var x in autoselectlist1) {
          ids.push(autoselectlist1[x].text)
        }
    }

    return (
      <tr style={{ position: "sticky", top: "50px", "zIndex": 11 }}>
        {getUpdateColum()?.map((col, index) => {
          if (index === 0) {
            return (
              <td key='action'>
                <span className='pe-2 cursor-pointer' onClick={onSearchFilter}>
                  <img src={searchIcon} alt='' />
                </span>
                <span className='cursor-pointer' onClick={onCancelFilter}>
                  <img src={crossIcon} alt='' />
                </span>
              </td>
            );
          }
          if (col.hideColFilter) {
            return <td key={col.dataField}></td>;
          }
          return (
            <td key={col.dataField} hidden={hasColselect ? (autoselectlist1.length > 0 ? !ids.includes(col.text) : false) : false}>
              <ColumnFilters
                col={col}
                onColumnFilterChange={handleColumnFilterChange}
                reset={resetField}
                sort={sort}
              />
            </td>
          );
        })}
      </tr>
    );
  };

  const getCurrentTableElement = () =>
    document
      .querySelector(`#${id}`)
      .getElementsByClassName('table-responsive')[0];

  const handleMouseEnter = () => {
    if (!id) return;
    const element = getCurrentTableElement();
    const rightScroll =
      element.scrollWidth - element.scrollLeft - element.clientWidth;
    if (rightScroll <= 10 && element.scrollLeft <= 10) return;
    if (element.scrollLeft <= 0) {
      setLeftArrow(false);
      setRightArrow(true);
    } else {
      setLeftArrow(true);
    }
    if (rightScroll <= 0) {
      setLeftArrow(true);
      setRightArrow(false);
    }
    setVisibleScrollArrow(true);
  };

  const handleMouseLeave = () => {
    setVisibleScrollArrow(false);
  };

  const scroll = (direction) => {
    const element = getCurrentTableElement();
    slideScroll(element, direction, 50, 500, 70);
  };

  const slideScroll = (element, direction, speed, distance, step) => {
    let scrollAmount = 0;
    var slideTimer = setInterval(function () {
      element.behavior = 'smooth';
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);


    setTimeout(() => {
      const el = getCurrentTableElement();
      const rightScroll = el.scrollWidth - el.scrollLeft - el.clientWidth;
      if (el.scrollLeft === 0) {
        setLeftArrow(false);
      } else {
        setLeftArrow(true);
      }
      if (rightScroll <= 0) {
        setRightArrow(false);
      } else {
        setRightArrow(true);
      }
    }, 500);
  };

  const renderScrollArrowButtons = () => {
    if (hasScrollArrow && hasVisibleScrollArrow && data && data.length) {
      return (
        <>
          {hasLeftArrow && (
            <Button
              onClick={() => scroll('left')}
              color='link'
              className={`left-table-button ${!hasLeftArrow ? 'opacity-25' : ''
                }`}
              disabled={!hasLeftArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={leftArrowIcon}
                alt='leftArrowIcon'
                height={60}
                width={60}
                style={{marginLeft:"50px"}}
              />
            </Button>
          )}
          {hasRightArrow && (
            <Button
              onClick={() => scroll('right')}
              color='link'
              className={`right-table-button ${!hasRightArrow ? 'opacity-25' : ''
                }`}
              disabled={!hasRightArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={rightArrowIcon}
                alt='rightArrowIcon'
                height={60}
                width={60}
              />
            </Button>
          )}
        </>
      );
    }
    return null;
  };

  const onClickFilter = (value) => {
    if (value === "on") {
      setRSelected(value);
      setColFilterEnable(true);
    } else {
      setResetField((pre) => !pre);
      setRSelected(value);
      setColFilterEnable(false);
      columnChangedFilters = [];
      // onFilterCancel();
      onCancelFilter();
    }
    columnChangedFilters = [];
  };
  const onHandlePageChange = (page) => {
    const pageFilter = { ...filters, currentPage: page };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageChange(colFilterOn, true, columnChangedFilters);
    }
    onPageChange(pageFilter);
  };

  const handlePageSizeChange = (e) => {
    const { value } = e.target;
    const pageFilter = {
      ...filters,
      currentPage: 1,
      pageSize: parseInt(value),
    };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageSizeChange(colFilterOn, true, columnChangedFilters);
    }
    setStartPage(2)
    onPageSizeChange(pageFilter);
  };

  return (
    <>


      <Row className="justify-content-end align-items-center py-2">
        <Col style={{ display: "flex", alignItems: "center" }} hidden={hidden}>
          <span className="text-dark f-14 font-weight-600">Display</span>
          <Input
            type="select"
            onChange={handlePageSizeChange}
            bsSize="sm"
            className="display-select d-inline-block pages_view"
            style={{ lineHeight: "20px" }}
            value={pageSize}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </Input>
          <span className="text-dark f-14 d-inline-block font-weight-500">
            records
          </span>

        </Col>
  
        <Col xs="auto">

        {onExport && (
              <Button
                size='sm'
                color='export'
                className='ms-auto'
                onClick={onExport}
                disabled={!data.length}
              >
                 <span className="">
                    <img style={{ width: "14px" }} src={download} alt="" />
                  </span> Export
              </Button>
              
            )}


          <span className='ps-3 pe-2 f-13 font-weight-600'
          // hidden={filtercolunm}
          >Filter</span>
          <ButtonGroup className='filter-btn-group'
          // hidden={filtercolunm}
          >
            <Button
              color='info'
              outline
              onClick={() => onClickFilter('off')}
              active={rSelected === 'off'}
            // disabled={!data.length}
            >
              OFF
            </Button>
            <Button
              color='info'
              outline
              onClick={() => onClickFilter('on')}
              active={rSelected === 'on'}
            // disabled={!data.length}
            >
              ON
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
      <div className='rounded-table'
        ref={selectRef}
        id={id}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseEnter}
      >
        {!loader && loading && <Loader opacity={0.01} color='black' />}
        {renderScrollArrowButtons()}
        <Table
          responsive
          id='reactstrap-table'
          className={`table table-striped theme-table ${fixedColumn && 'fixed-column-table'
            }`}
          style={{ scrollBehavior: 'smooth' }}
        >
          {headerRenderer()}
          <tbody>
            {colFilterEnable && columnFilters()}
            {renderRow()}
          </tbody>
        </Table>
      </div>
<div hidden={hidden}>
 <Pagination
        onPageChange={onHandlePageChange}
        currentPage={currentPage}
        totalRecords={totalRecords}
        pageSize={pageSize}
        startPage={startPage}
        setStartPage={setStartPage}
        hasNoEligibility={hasNoEligibility}
        researchNeededCount={researchNeededCount}
        eligibleCount={eligibleCount}
        inEligibleCount={inEligibleCount}
      />
</div>
     
    </>
  );
};

export default ReactStrapTable;
